import Login from "./Login";
import OtpForm from "./OtpForm";
import SignUp from "./SignUp";
import CreatePassword from "./CreatePassword";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";

export {
  Login,
  SignUp,
  OtpForm,
  CreatePassword,
  ForgotPassword,
  ResetPassword,
};
